module.exports = __webpack_public_path__ + "static/media/correct.1a507629.svg";